import { Gender } from 'fitbeat.models';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import BodyGroupsImageFemale from '../assets/images/strengthAssessmentBodyGroupsFemale.svg';
import BodyGroupsImageMale from '../assets/images/strengthAssessmentBodyGroupsMale.svg';
import { defaultScale } from '../utils/scaling';
import { IStrengthResult, svgFillPropertyToBodyGroup } from './selectors';
import { SingleBodyGroupResultDisplay } from './SingleBodyGroupResultDisplay';

const getCorrectColorForProp = (results: IStrengthResult[], prop: string) => {
  const matchingResult = results.find((result) => {
    return result.primaryMuscleMover === svgFillPropertyToBodyGroup[prop];
  });
  return matchingResult?.color;
};

interface IProps {
  results: IStrengthResult[];
  gender: Gender;
}

export const StrengthSummary: React.FC<IProps> = ({ results, gender }) => {
  const BodyGroupImage = gender === Gender.Male ? BodyGroupsImageMale : BodyGroupsImageFemale;
  return (
    <>
      <View style={styles.imageContainer}>
        <BodyGroupImage
          width={'100%'}
          height={'100%'}
          fill={getCorrectColorForProp(results, 'fill')}
          fillSecondary={getCorrectColorForProp(results, 'fillSecondary')}
          color={getCorrectColorForProp(results, 'color')}
          colorSecondary={getCorrectColorForProp(results, 'colorSecondary')}
          colorFour={getCorrectColorForProp(results, 'colorFour')}
          colorFive={getCorrectColorForProp(results, 'colorFive')}
          colorSix={getCorrectColorForProp(results, 'colorSix')}
          colorSeven={getCorrectColorForProp(results, 'colorSeven')}
          colorEight={getCorrectColorForProp(results, 'colorEight')}
        />
      </View>
      <View style={{ alignItems: 'center' }}>
        {results.map((result) => {
          return <SingleBodyGroupResultDisplay key={result.primaryMuscleMover} result={result} />;
        })}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  imageContainer: {
    marginVertical: defaultScale(30),
    flex: 1,
  },
});
